
    <!-- Backdrop -->
    @if (showBackdrop) {
    <div [class]="computedBackdropClasses()" (click)="closeOnBackdrop && close()" [attr.aria-hidden]="true"></div>
    }

    <!-- Bottom Sheet -->
    <div
      #bottomSheetElement
      [class]="computedBottomSheetClasses()"
      [attr.aria-hidden]="isOpen() ? null : 'true'"
      [attr.aria-label]="ariaLabel"
      role="dialog"
      (keydown)="handleKeyDown($event)"
    >
      <!-- Glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden"
      >
        <div
          class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                    transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                    transition-transform duration-1500 ease-out"
        ></div>
      </div>

      <!-- Premium floating particles -->
      @if (variant === 'premium') {
      <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
        <div class="absolute top-1/4 left-1/6 w-2 h-2 bg-primary-400/40 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/3 right-1/4 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse delay-1000"></div>
        <div class="absolute top-3/4 left-3/4 w-1 h-1 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
      </div>
      }

      <!-- Bottom Sheet Content -->
      <div [class]="computedContentClasses()">
        <!-- Drag Handle -->
        @if (showDragHandle) {
        <div class="shrink-0 flex justify-center pt-3 pb-2">
          <div class="h-1.5 w-12 rounded-full bg-blue-200/18 opacity-90"></div>
        </div>
        }

        <!-- Header -->
        @if (hasHeader) {
        <div class="shrink-0 p-6 border-b border-blue-200/10 relative">
          <div class="flex items-center justify-between relative z-10">
            <div>
              @if (title) {
              <h2 class="text-xl font-semibold text-white">
                {{ title }}
              </h2>
              } @if (subtitle) {
              <p class="mt-1 text-sm text-slate-300">
                {{ subtitle }}
              </p>
              }
            </div>

            @if (showCloseButton) {
            <button
              (click)="handleCloseClick($event)"
              class="relative z-20 inline-flex items-center justify-center rounded-2xl border border-blue-200/18 bg-slate-900/35 p-2 text-slate-300 transition-all duration-200 hover:border-blue-200/28 hover:bg-white/8 hover:text-white
                         focus:ring-2 focus:ring-primary-500/50 focus:outline-none
                         cursor-pointer"
              [attr.aria-label]="'Close ' + (title || 'bottom sheet')"
            >
              <ui-icon name="x" size="md"></ui-icon>
            </button>
            }
          </div>

          <!-- Header glass accent -->
          <div
            class="absolute inset-0 bg-linear-to-r from-primary-500/5 to-transparent
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          ></div>
        </div>
        }

        <!-- Content Area -->
        <div class="flex-1 overflow-y-auto relative">
          <div class="relative z-10">
            <ng-content></ng-content>
          </div>
        </div>

        <!-- Footer -->
        @if (hasFooter) {
        <div class="shrink-0 p-6 border-t border-blue-200/10 relative">
          <div class="relative z-10">
            <ng-content select="[slot=footer]"></ng-content>
          </div>

          <!-- Footer glass accent -->
          <div
            class="absolute inset-0 bg-linear-to-r from-transparent to-primary-500/5
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          ></div>
        </div>
        }
      </div>

      <!-- Open state glow -->
      @if (isOpen()) {
      <div class="absolute inset-0 opacity-30 pointer-events-none">
        <div class="absolute inset-0 bg-primary-500/5 animate-glass-pulse"></div>
      </div>
      }
    </div>
  
